var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogFull',{attrs:{"data":_vm.dialogSettings},on:{"close":_vm.close}},[_c('div',{staticClass:"container col-lg-8 col-sm-12"},[_c('LanguagesAndSkills',{attrs:{"submitButtonTitle":"Save Changes"},on:{"close":_vm.close}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }